import React from "react";
import Head from "next/head";

/**
 * Render a schema.org JSON-LD object into <head>. Same shape the site's
 * pages already inline; centralised so the site-wide product schema and
 * per-page HowTo/FAQ blocks share one code path.
 */
export default function JsonLd({ data }: { data: unknown }) {
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  );
}
